import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PinIcon(props: IconProps) {
    return <Icon {...props} iconKey={"pin"}/>
}
